import regeneratorRuntime from "/app/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Select from '@/components/base/Select';
import Icon from '@/components/base/Icon';
import { useCallback, useEffect, useState } from 'react';
import useLanguage from '@/hooks/useLanguage';
import getShardService from '@/api/shard';
import { toShard } from '@/utils/string';
import { useRouter } from 'next/router';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var shardService = getShardService();
var Extra = function(props) {
    var ref = useState([]), shards = ref[0], setShardItems = ref[1];
    var onShardChange = props.onShardChange, total = props.total, _defaultShard = props.defaultShard, defaultShard = _defaultShard === void 0 ? '' : _defaultShard;
    var translate = useLanguage().translate;
    var router = useRouter();
    useEffect(function() {
        getShards();
    }, []);
    var getShards = useCallback(_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    shardService.getShardList().then(function(response) {
                        setShardItems([
                            {
                                label: translate('All Shard'),
                                value: ''
                            }
                        ].concat(_toConsumableArray((response.Result || []).sort(function(r) {
                            return r.ShardIndex === 65535 ? -1 : 1;
                        }).map(function(r) {
                            return {
                                label: "Shard".concat(toShard(r.ShardIndex)),
                                value: String(r.ShardIndex)
                            };
                        }))));
                    });
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), []);
    var handleShardChange = useCallback(function(selected) {
        // const newUrl = router.pathname + selected ? `?s=${selected}` : ''
        // router.replace(newUrl)
        onShardChange(selected);
    }, [
        onShardChange
    ]);
    return(/*#__PURE__*/ _jsxs("div", {
        className: "flex mr-[10px]",
        children: [
            /*#__PURE__*/ _jsx(Select, {
                options: shards,
                className: "!min-w-[128px] text-base",
                placeholder: translate('All shard'),
                onChange: handleShardChange,
                selected: defaultShard
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "self-center",
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        type: "bar",
                        className: "mr-[8px] ml-[32px] text-[16px] text-desc"
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        className: "text-desc font-[400] text-[14px] leading-[17px]",
                        children: translate('Recent %s Transactions', total)
                    })
                ]
            })
        ]
    }));
};
export default Extra;
